var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import axios from "axios";
import { useCallback, useContext, useEffect, useState } from "react";
import { AssetsList } from "../store/types";
import { isProduction } from "../utils/env";
import { defaultAssetsPriceData, ExternalAPIDataContext, } from "./externalAPIDataContext";
import { COINGECKO_BASE_URL, COINGECKO_CURRENCIES, } from "../constants/constants";
var getAssetPricesInUSD = function (currencyName) { return __awaiter(void 0, void 0, void 0, function () {
    var apiURL, response, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                apiURL = COINGECKO_BASE_URL + "/coins/" + currencyName + "/market_chart?vs_currency=usd&days=365&interval=daily";
                return [4 /*yield*/, axios.get(apiURL)];
            case 1:
                response = _a.sent();
                data = response.data;
                return [2 /*return*/, data.prices.map(function (_a) {
                        var timestamp = _a[0], price = _a[1];
                        return ({
                            timestamp: timestamp,
                            price: price,
                        });
                    })];
        }
    });
}); };
export var useFetchAssetsPrice = function (_a) {
    var _b = _a === void 0 ? { poll: true, pollingFrequency: 120000 } : _a, poll = _b.poll, pollingFrequency = _b.pollingFrequency;
    var _c = useState(defaultAssetsPriceData), data = _c[0], setData = _c[1];
    var _d = useState(true), loading = _d[0], setLoading = _d[1];
    var fetchAssetsPrices = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var responses, todayTimestamp;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!isProduction()) {
                        console.time("Asset Price Data Fetch"); // eslint-disable-line
                    }
                    return [4 /*yield*/, Promise.all(__spreadArray([], AssetsList).map(function (asset) { return __awaiter(void 0, void 0, void 0, function () {
                            var currencyName, _a;
                            var _b;
                            return __generator(this, function (_c) {
                                switch (_c.label) {
                                    case 0:
                                        currencyName = COINGECKO_CURRENCIES[asset];
                                        _b = {
                                            asset: asset
                                        };
                                        if (!currencyName) return [3 /*break*/, 2];
                                        return [4 /*yield*/, getAssetPricesInUSD(currencyName)];
                                    case 1:
                                        _a = _c.sent();
                                        return [3 /*break*/, 3];
                                    case 2:
                                        _a = [];
                                        _c.label = 3;
                                    case 3: return [2 /*return*/, (_b.data = _a,
                                            _b)];
                                }
                            });
                        }); }))];
                case 1:
                    responses = _a.sent();
                    todayTimestamp = new Date(new Date().toDateString());
                    todayTimestamp.setHours(0 - todayTimestamp.getTimezoneOffset() / 60);
                    setData(Object.fromEntries(responses
                        .map(function (response) { return [
                        response.asset,
                        {
                            latestPrice: response.data.length > 0
                                ? response.data[response.data.length - 1].price
                                : 0,
                            history: Object.fromEntries(response.data.map(function (item) { return [item.timestamp, item.price]; })),
                        },
                    ]; })
                    // .concat([
                    //   [
                    //     "USDC",
                    //     {
                    //       latestPrice: 1,
                    //       history: Object.fromEntries(
                    //         [...new Array(365)].map((_, index) => [
                    //           todayTimestamp.valueOf() - index * (1000 * 60 * 60 * 24),
                    //           1,
                    //         ])
                    //       ),
                    //     },
                    //   ],
                    // ])
                    ));
                    setLoading(false);
                    if (!isProduction()) {
                        console.timeEnd("Asset Price Data Fetch"); // eslint-disable-line
                    }
                    return [2 /*return*/];
            }
        });
    }); }, []);
    useEffect(function () {
        fetchAssetsPrices();
        var pollInterval = undefined;
        if (poll) {
            pollInterval = setInterval(fetchAssetsPrices, pollingFrequency);
        }
        return function () {
            if (pollInterval) {
                clearInterval(pollInterval);
            }
        };
    }, [fetchAssetsPrices, poll, pollingFrequency]);
    return { data: data, loading: loading };
};
var useAssetPrice = function (_a) {
    var _b = _a === void 0 ? { asset: "WETH" } : _a, asset = _b.asset;
    var contextData = useContext(ExternalAPIDataContext);
    // console.group('useAssetPrice')
    //   console.log(contextData)
    // console.groupEnd()
    return {
        price: contextData.assetsPrice.data[asset] ? contextData.assetsPrice.data[asset].latestPrice : 0,
        loading: contextData.assetsPrice.loading,
    };
};
export default useAssetPrice;
export var useAssetsPrice = function () {
    var contextData = useContext(ExternalAPIDataContext);
    // console.log('loading useAssetsPrice:', contextData.assetsPrice.loading)
    return {
        prices: Object.fromEntries(AssetsList.map(function (asset) { return [
            asset,
            contextData.assetsPrice.data[asset].latestPrice,
        ]; })),
        loading: contextData.assetsPrice.loading,
    };
};
export var useAssetsPriceHistory = function () {
    var contextData = useContext(ExternalAPIDataContext);
    /**
     * Search the price of asset with a given date
     */
    var searchAssetPriceFromDate = useCallback(function (asset, date) {
        var queryDate = new Date(date.toDateString());
        queryDate.setUTCHours(0);
        return (contextData.assetsPrice.data[asset] ?
            (contextData.assetsPrice.data[asset].history[queryDate.valueOf()] || 0) :
            0);
    }, [contextData.assetsPrice]);
    /**
     * Wrapper for price search in the event where moment is provided
     */
    var searchAssetPriceFromMoment = useCallback(function (asset, momentObj) {
        return searchAssetPriceFromDate(asset, momentObj.toDate());
    }, [searchAssetPriceFromDate]);
    /**
     * Wrapper for price search in the event where timestamp is provided
     */
    var searchAssetPriceFromTimestamp = useCallback(function (asset, timestamp) {
        return searchAssetPriceFromDate(asset, new Date(timestamp));
    }, [searchAssetPriceFromDate]);
    return {
        histories: Object.fromEntries(AssetsList.map(function (asset) { return [
            asset,
            contextData.assetsPrice.data[asset].history,
        ]; })),
        searchAssetPriceFromDate: searchAssetPriceFromDate,
        searchAssetPriceFromMoment: searchAssetPriceFromMoment,
        searchAssetPriceFromTimestamp: searchAssetPriceFromTimestamp,
        loading: contextData.assetsPrice.loading,
    };
};
export var useAssetInfo = function (asset) {
    var _a = useState(false), loading = _a[0], setLoading = _a[1];
    var _b = useState(), info = _b[0], setInfo = _b[1];
    var fetchAssetInfo = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var apiURL, response, data, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (info) {
                        return [2 /*return*/];
                    }
                    apiURL = COINGECKO_BASE_URL + "/coins/" + COINGECKO_CURRENCIES[asset];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    setLoading(true);
                    return [4 /*yield*/, axios.get(apiURL)];
                case 2:
                    response = _a.sent();
                    data = response.data;
                    setInfo({
                        circulating_supply: data.market_data.circulating_supply,
                    });
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _a.sent();
                    !isProduction() && console.log("Asset info fetch error:", error_1); // eslint-disable-line
                    setInfo({
                        circulating_supply: 0,
                    });
                    return [3 /*break*/, 5];
                case 4:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [info, asset]);
    useEffect(function () {
        fetchAssetInfo();
    }, [fetchAssetInfo]);
    return {
        info: info || { circulating_supply: 0 },
        loading: loading,
    };
};
//# sourceMappingURL=useAssetPrice.js.map